import router from '@uirouter/angularjs';
import '@nsoft/seven-ng-socket/dist/nab-ng-socket';
import '@nsoft/seven-ng-client-core/dist/seven-ng-client-core';
import UserModule from '../src/user';
import ShopModules from '../src/modules';
import CoreModule from '../src/core';
import CommonModule from '../src/common';
import integratorModule from '../src/modules/integrator';
import CustomerCardsModule from '../src/modules/customer_cards';

/**
   * @module "7Shop.Bootstrap"
   */
angular.module('7Shop.Bootstrap', [
  router,
  'SevenClient.Config',
  'SevenClientCore',
  CommonModule,
  UserModule,
  ShopModules,
  CoreModule,
  integratorModule,
  CustomerCardsModule
]);
